import { Form } from 'formik';

import { VStack } from '@frontend/legacy-components';

import { FormActions } from './FormActions';

type SubFormWrapperProps = {
  isValid: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  renderSelectedType: () => React.ReactNode;
  submitLabel: string;
  children: React.ReactNode;
};

export const SubFormWrapper = ({
  isValid,
  isSubmitting,
  onCancel,
  renderSelectedType,
  submitLabel,
  children,
}: SubFormWrapperProps) => {
  return (
    <VStack as={Form} spacing={0} align="stretch">
      <VStack
        spacing={1}
        pb={0}
        align="stretch"
        maxHeight="500px"
        overflow="auto"
      >
        {renderSelectedType()}
        {children}
      </VStack>
      <FormActions
        onCancel={onCancel}
        isValid={isValid}
        isSubmitting={isSubmitting}
        submitLabel={submitLabel}
      />
    </VStack>
  );
};
